<template>
  <g>
    <path
      style="fill: rgb(33, 133, 63)"
      d="M44.5,22.8c-0.4-0.4-1-0.6-1.5-0.6c-0.6,0-1.1,0.3-1.5,0.7L29.7,36l-6.1-5.1c-0.4-0.4-1-0.5-1.5-0.5
                    c-0.6,0-1.1,0.3-1.4,0.7c-0.7,0.9-0.6,2.2,0.3,3l9.2,7.8l14.6-16C45.4,25,45.4,23.6,44.5,22.8"
    />
    <path
      style="fill: rgb(33, 133, 63)"
      d="M32,64c-8.5,0-16.6-3.3-22.6-9.4S0,40.5,0,32c0-8.5,3.3-16.6,9.4-22.6C15.4,3.3,23.5,0,32,0s16.6,3.3,22.6,9.4
                    c12.5,12.5,12.5,32.8,0,45.3C48.6,60.7,40.6,64,32,64 M32,3.8c-7.5,0-14.6,2.9-20,8.3c-5.3,5.3-8.3,12.4-8.3,20
                    c0,7.5,2.9,14.6,8.3,20c5.3,5.3,12.4,8.3,20,8.3s14.6-2.9,20-8.3C63,40.9,63,23,52,12C46.6,6.7,39.5,3.8,32,3.8"
    />
  </g>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconVinkjeAppendix extends Vue {}
</script>
